"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instantiatePreactComponents = exports.initializeApp = exports.bindPreactComponents = void 0;

var _initialiseComponent = _interopRequireDefault(require("./initialiseComponent"));

var _globals = require("@insided/shared/utils/globals");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _bootstrap = require("@insided/shared/bootstrap");

var _twigTooltipBridge = require("../services/twig-tooltip-bridge");

var instantiatePreactComponents = (0, _bootstrap.createComponentInstantiator)('[data-preact]', _initialiseComponent.default, 'preact');
exports.instantiatePreactComponents = instantiatePreactComponents;
var bindPreactComponents = (0, _bootstrap.createComponentBinder)(instantiatePreactComponents);
exports.bindPreactComponents = bindPreactComponents;

var initializeApp = function initializeApp() {
  window.insided = {
    initialiseComponent: _initialiseComponent.default,
    bindPreactComponents: bindPreactComponents,
    trackEvent: _publish.default.trackEvent,
    publish: _globals.publish
  }; // Initialize components

  bindPreactComponents(document); // Set up global publishers

  (0, _bootstrap.addGlobalPublishers)(); // GE-238129: twig → Preact Tooltip bridge. No-op unless the
  // experimental_preactTooltipMigration flag is active. See
  // services/twig-tooltip-bridge/AGENTS.md for why this exists and when
  // it gets deleted.

  (0, _twigTooltipBridge.initPreactTooltips)();
};

exports.initializeApp = initializeApp;